// Import your JS controllers here and then make them globally
// available by setting them to window
import RideEstimateController from './controllers/ride-estimate-controller';
import RequestARideController from './controllers/request-a-ride-controller';
import RequestARideSummaryController from './controllers/request-a-ride-summary-controller';
import '../../../../../library/js/components/google-captcha-3';
import '../components/web';

window.RideEstimateController = RideEstimateController;
window.RequestARideController = RequestARideController;
window.RequestARideSummaryController = RequestARideSummaryController;

$(document).ready(function () {
  $('#mobileMenuButton').click(function () {
    $('#menuMobile').toggleClass('shown');
    $('.menu-section').toggleClass('shown');
  });
  $('#exitButton').click(function () {
    $('#menuMobile').toggleClass('shown');
    $('.menu-section').toggleClass('shown');
  });
});
